import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { feedbackQueryKeys } from "@/feedback/data/feedbackQueryKeys";
import { FeedbackQuery } from "@reflag/shared/feedbackAPI";

export function useFeedbackData(
  params?: Omit<FeedbackQuery, "envId">,
  enabled = true,
) {
  const { appId, envId } = useEnvironment();
  return useQuery({
    queryKey: feedbackQueryKeys.list(appId, envId, params),
    queryFn: () =>
      api
        .get<`/apps/:appId/feedback`>(`/apps/${appId}/feedback`, {
          params: {
            ...params,
            envId: envId!,
          },
        })
        .then((res) => res.data),
    enabled: !!appId && !!envId && enabled,
    placeholderData: keepPreviousData,
  });
}
